import styles from './MainContainer.module.scss';
import { Container } from "@mui/material";
const MainContainer = ({ children, title }) => {
    return (
        <div className={styles.mainContainer}>
            <h1>{title}</h1>
            <div className={styles.content}>
                {children}
            </div>
        </div>
    );
}

export default MainContainer;